import React from "react"
import { AuthenticationLayout } from "layoutsV2/client/AuthenticationLayout"
import { CreatePassword as CreatePasswordForm } from "ui/auth/PasswordRecovery/CreatePassword"

export const PasswordRecoveryCreatePassword = () => (
  <AuthenticationLayout type="signin">
    <CreatePasswordForm />
  </AuthenticationLayout>
)
